// PA-D tier default from grade (Step 0 decision 7, mapping pinned by Kemal).
// Input is the app's canonical grade enum (roleConfig FALLBACK_GRADE_LEVELS
// values, which is also what the Clever importer writes to class.grade and
// what onboarding writes to users.grade). This map lives INSIDE PA-D by
// decision — never promote it to a fifth shared grade normalizer.
//
// Default ladder (implemented by the Assessment page, not here):
//   class.grade -> teacher's users.grade -> no default (tier control shows
//   unselected; the pre-session checklist cannot be confirmed until a tier is
//   chosen). The default is a suggestion — one tap changes it.

const GRADE_ENUM_TO_TIER = {
  'Early Childhood': '4k',
  'Pre-K': '4k',
  'Kindergarten': 'k',
  '1st Grade': 'grade1',
  '2nd Grade': 'grade2-3',
  '3rd Grade': 'grade2-3',
};

/**
 * @param {string|null|undefined} gradeEnumValue  canonical grade enum value.
 * @returns {'4k'|'k'|'grade1'|'grade2-3'|null} null = no default ('Other',
 *   null, free text, anything unrecognized).
 */
export function gradeToTier(gradeEnumValue) {
  if (typeof gradeEnumValue !== 'string') return null;
  return GRADE_ENUM_TO_TIER[gradeEnumValue] || null;
}
